import React from "react";
import styled from "styled-components";
import { AlertCircle, CheckCircle, Info, XCircle } from "react-feather";

const tones = {
  info: {
    border: "rgba(34, 184, 209, 0.24)",
    background: "rgba(34, 184, 209, 0.1)",
    icon: "#8FE3F2",
    text: "#e0f2fe",
  },
  success: {
    border: "rgba(74, 222, 128, 0.24)",
    background: "rgba(74, 222, 128, 0.1)",
    icon: "#8FE3F2",
    text: "#dcfce7",
  },
  warning: {
    border: "rgba(250, 204, 21, 0.24)",
    background: "rgba(250, 204, 21, 0.1)",
    icon: "#fde047",
    text: "#fef9c3",
  },
  error: {
    border: "rgba(248, 113, 113, 0.24)",
    background: "rgba(248, 113, 113, 0.1)",
    icon: "#fca5a5",
    text: "#fee2e2",
  },
};

const iconByTone = {
  info: Info,
  success: CheckCircle,
  warning: AlertCircle,
  error: XCircle,
};

const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid ${({ $tone }) => tones[$tone].border};
  background: ${({ $tone }) => tones[$tone].background};
  color: ${({ $tone }) => tones[$tone].text};
  line-height: 1.6;
`;

const IconBox = styled.div`
  flex: 0 0 auto;
  color: ${({ $tone }) => tones[$tone].icon};
  margin-top: 1px;
`;

const Content = styled.div`
  display: grid;
  gap: 2px;
`;

const Title = styled.strong`
  color: #f4f7fc;
  font-size: 0.96rem;
`;

const Message = styled.div`
  font-size: 0.95rem;
`;

export default function InlineAlert({ tone = "info", title, children, ...rest }) {
  const Icon = iconByTone[tone] || Info;

  return (
    <Wrapper $tone={tone} {...rest}>
      <IconBox $tone={tone}>
        <Icon size={18} />
      </IconBox>
      <Content>
        {title ? <Title>{title}</Title> : null}
        <Message>{children}</Message>
      </Content>
    </Wrapper>
  );
}
